import type { FaireProductEntity } from "../../entity_types/product";

export const p_cyxrudx2uw: FaireProductEntity = {
  token: "p_cyxrudx2uw",
  type: "product",
  name: "Organic Lip Balm, 12 Ct Variety Box, Clean Beauty Assortment",
  brandToken: "b_ergh8dkpkq",
  brandName: "Kind Lips",
  imageUrl:
    "https://cdn.faire.com/fastly/956f29228578819549eb31022bf8703ef5e6d7288d037743c49224e9b7275165.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1084d37770b47d3c27063ca1f4b9d1bdd04771994e3fa12e228cb0d839abdab8.png",
    "https://cdn.faire.com/fastly/5ead67592e8ead05f2b53d9bd1a61d258d991b2ff9c241a1bceeb1dbc3d2ea94.jpeg",
    "https://cdn.faire.com/fastly/af92589de4c137767a632cff267a186f3c2525f27dec2115d6f0b7a249f4d47d.png",
    "https://cdn.faire.com/fastly/013d0331b729999b7690d1da17da0f49235e22c7236b10446cebfbc9f0800d94.png",
    "https://cdn.faire.com/fastly/16dbe288bc2b82d7b1c07e0df6f0f265e8a631bfe9bb5288a9525a7acacc2cb5.png",
    "https://cdn.faire.com/fastly/b1d846e1d403bb5d2581a05c6468a05e2349a8da46b860d2379bdac79d56ffad.png",
  ],
  priceDollars: 2.5,
  description:
    "Give your customers an easy, high-impact clean-beauty option with this 12 Ct Organic Lip Balm Variety Box. This best-selling assortment includes three universally loved flavors—Sweet Mint, Wild Cherry, and Vanilla Lemon—each crafted with a simple, organic formula that appeals to every age and gifting occasion.\n\nMade in the USA with coconut oil, beeswax, shea butter, and other clean, natural ingredients, every tube offers smooth hydration and everyday lip care shoppers trust. The curated flavor mix makes this an ideal counter item, add-on purchase, or grab-and-go gift.\n\nDesigned for boutiques, gift shops, wellness stores, and general retail, this 12-piece set is display-ready and moves quickly thanks to familiar flavors, approachable pricing, and strong repeat purchase behavior. Every purchase supports a nonprofit school program designed to address the root causes of bullying, self-harm, and school violence, helping students build healthier communication habits.\n\nWhat’s Included:\n• 12 tubes total (4 each of Sweet Mint, Wild Cherry, Vanilla Lemon)\n• Organic, natural, gluten-free, and grain-free formula\n• Gentle, everyday lip care made in small batches in the USA\n• Ideal for point-of-sale displays, gifting, and customer sampling",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:39.629Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
